import { ReactElement } from 'react';

import { MedicineSafetyIndicatorIcon } from './MedicineSafetyIndicatorIcon';
import { StyledMedicineSafetyIndicators } from './MedicineSafetyIndicators.styled';

type MedicineSafetyIndicatorsProps = {
   readonly medicineId: number;
};

export const MedicineSafetyIndicators = (props: MedicineSafetyIndicatorsProps): ReactElement => {
   return (
      <StyledMedicineSafetyIndicators>
         <MedicineSafetyIndicatorIcon medicineId={props.medicineId} indicatorType={'drivingCar'} />
         <MedicineSafetyIndicatorIcon medicineId={props.medicineId} indicatorType={'interactionWithAlcohol'} />
         <MedicineSafetyIndicatorIcon medicineId={props.medicineId} indicatorType={'breastFeeding'} />
         <MedicineSafetyIndicatorIcon medicineId={props.medicineId} indicatorType={'pregnantFirstTrimester'} />
         <MedicineSafetyIndicatorIcon medicineId={props.medicineId} indicatorType={'pregnantSecondTrimester'} />
         <MedicineSafetyIndicatorIcon medicineId={props.medicineId} indicatorType={'pregnantThirdTrimester'} />
      </StyledMedicineSafetyIndicators>
   );
};
